export const TEXT_EDIT_EVENTS = {
    RANGE_CHANGE: 'text-edit/range-change',
    ALLOW_UPDATE_MANUAL: 'text-edit/allow-update-manual',
    MOUSE_DOWN: 'text-edit/mouse-down',
    BEFORE_ENTER_EDITING: 'text-edit/before-enter-editing',
};

export const EDIT_AREA_ID_SELECTOR = 'j-text-edit-area';
